import { render, staticRenderFns } from "./AuthCard.vue?vue&type=template&id=72184c3c"
var script = {}
import style0 from "./AuthCard.vue?vue&type=style&index=0&id=72184c3c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports